import { styled } from 'styled-components';

// eslint-disable-next-line no-restricted-imports
import { MqMobileOnly, MqTablet } from '~theme/media';
import { visualHideScrollbar } from '~theme/snippets';

export const StyledSuggestedTextListContainer = styled.div`
	display: flex;
	width: 100%;
	justify-content: flex-start;
	padding: 0.4rem 2rem;
	margin: 3rem -2rem 0;
	grid-area: suggested-text;
	-webkit-mask-image: linear-gradient(
		270deg,
		transparent,
		rgba(0, 0, 0, 1) 3rem,
		rgba(0, 0, 0, 1) calc(100% - 3rem),
		transparent
	);
	overflow-x: scroll;
	place-self: center;

	${MqTablet} {
		overflow-x: auto;
	}

	${MqMobileOnly} {
		${visualHideScrollbar};
	}

	@media (hover: none) {
		scrollbar-width: none; /* Firefox */

		&::-webkit-scrollbar {
			display: none; /* Safari and Chrome */
		}
	}
`;

export const StyledSuggestedTextList = styled.div`
	display: flex;
	min-width: max-content;
	justify-content: flex-start;
	gap: 6px;
`;
